export const CALCULATOR_INTRO_TITLE = 'Calcule o preço certo antes de aceitar um pedido.';

export const CALCULATOR_INTRO_BODY =
    'Simule multipartes, embalagem, marketplace e maquininha e descubra, em segundos, o mínimo que você precisa cobrar para não sair no prejuízo.';

export const CALCULATOR_INTRO_PUBLIC =
    `${CALCULATOR_INTRO_BODY}<br />Configure uma vez, use sempre. Grátis e sem login!`;

export const CALCULATOR_INTRO_LOGGED =
    `${CALCULATOR_INTRO_BODY}<br />Configure uma vez, use sempre.`;
